/** FAQ anchor for linking, duplicate accounts, and support-led merges. */
export const SIGN_IN_METHODS_FAQ_PATH = '/faq#sign-in-methods';
